import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import SchoolIcon from '@material-ui/icons/School';
import EventIcon from '@material-ui/icons/Event';
import VideoLibrary from '@material-ui/icons/VideoLibrary';
import LibraryMusic from '@material-ui/icons/LibraryMusic';
import LogoutIcon from '../../static/img/icons/logout_icon.png';
import ClothingIcon from '../../static/img/icons/clothing_icon.svg';
import NiaTVIcon from '../../static/img/icons/niatv_icon.svg';
// import MembershipIcon from '../../static/img/icons/membership.png';
import RoutineIcon from '../../static/img/icons/routine_icon.png';
import GoogleTranslateStyles from '../../static/css/googleTranslateStyles.js';


class NavMenus extends React.Component {
  constructor(props) {
    super(props);
    this.simulateClick = this.simulateClick.bind(this);
  }

  // Google Translate only allows one gadget per page
  // but we need two buttons that open it up because
  // of the way our nav works. This simulates a click
  // to the gadget from a button in the collapsed mobile nav
  simulateClick() {
    // simulate the click
    const el = document.getElementsByClassName('goog-te-gadget-simple')[0];
    el.click();
    // we have to manually style because this is an iframe loaded by google
    function changeGoogStyles() {
      // get the frame
      const gm = document.getElementsByClassName('goog-te-menu-frame')[0];
      gm.style.display = 'block'
      // get the document of the frame
      const gmDoc = gm.contentDocument || gm.contentWindow.document;
      // get the actual menu
      const gm2 = gmDoc.getElementsByClassName('goog-te-menu2')[0];
      // check if it exists cause it loads asynchronously
      if (gm2) { // if it exists..
        // create custom string of inline styles.. so ugly
        const stylesHTML = '<style type="text/css" id="cssId">' + GoogleTranslateStyles + '</style>';
        // prepend it here not sure why this place worked
        const gmHead = gmDoc.getElementsByTagName('head')[0];
        gmHead.innerHTML = stylesHTML + gmHead.innerHTML;
      } else {
        // otherwise, keep trying until it
        setTimeout(changeGoogStyles, 50);
      }
    }
    // had to add a small wait here cause it was opening and closing too quickly? weird
    setTimeout(changeGoogStyles, 100);
  }

  render() {
    const {
      classes,
      user,
      anchorEl0,
      anchorEl6,
      anchorEl5,
      // anchorEl4,
      anchorEl3,
      anchorEl2,
      anchorEl,
      mobileMoreAnchorEl,
      aboutMenuOpen,
      handleAboutMenu,
      handleAboutClose,
      shopMenuOpen,
      handleShopMenu,
      handleShopClose,
      trainingsMenuOpen,
      handleTrainingsMenu,
      handleTrainingsClose,
      eventsMenuOpen,
      // handleEventsMenu,
      handleEventsClose,
      // membershipMenuOpen,
      // handleMembershipMenu,
      // handleMembershipClose,
      classesMenuOpen,
      handleClassesMenu,
      handleClassesClose,
      userMenuOpen,
      handleUserMenu,
      handleUserClose,
      mobileMenuOpen,
      handleMobileMenuClose,
    } = this.props;

    return (
      <React.Fragment>

        {/* ABOUT MENU */}
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl0}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          open={aboutMenuOpen}
          onClose={handleAboutClose}
        >

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/about-nia"
          >
            <ListItemText primary="About Nia" />
          </MenuItem>

          <Divider />

          {/*<MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/class-intro"
          >
            <ListItemIcon>
              <InfoIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="About Nia Classes" />
          </MenuItem>
          <Divider />*/}

          {/*<MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/training-intro"
          >
            <ListItemIcon>
              <InfoIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="About Nia Trainings" />
          </MenuItem>
          <Divider />*/}

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/testimonials"
          >
            <ListItemText primary="Testimonials + Reviews" />
          </MenuItem>

          <Divider />
{/*
          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/blog"
          >
            <ListItemText primary="Blog + Community" />
          </MenuItem>*/}

          <Divider />

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/faq"
          >
            <ListItemText primary="Frequently Asked Questions" />
          </MenuItem>

          <Divider />

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/membership"
          >
            <ListItemText primary="Membership" />
          </MenuItem>

          <Divider />

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/dei"
          >
            <ListItemText primary="DEI Commitments" />
          </MenuItem>

          {/*<Divider />

          <MenuItem
            onClick={handleAboutClose}
            component={Link}
            to="/press-room"
          >
            <ListItemIcon>
              <InfoIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Nia Press Room" />
          </MenuItem>*/}

        </Menu>

        {/* CLASSES MENU */}
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          open={classesMenuOpen}
          onClose={handleClassesClose}
        >

          <MenuItem
            onClick={handleClassesClose}
            component={Link}
            to="/classes"
          >
            <ListItemIcon>
              <InfoIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find your Nia" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleClassesClose}
            component={Link}
            to="/finder/class"
          >
            <ListItemIcon>
              <SearchIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find a Class" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleClassesClose}
            component={Link}
            to="/finder/teacher"
          >
            <ListItemIcon>
              <SearchIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find a Teacher" />
          </MenuItem>
          <Divider />

          <a target="_blank" rel="noopener noreferrer" className={classes.externalLink} href="https://niaondemand.com">
            <MenuItem>
              <ListItemIcon>
                <img src={NiaTVIcon} alt="nia on demand" className={classes.navIconCustom} />
              </ListItemIcon>
              <ListItemText primary="On-Demand Classes" />
            </MenuItem>
          </a>



        </Menu>

        {/* TRAININGS MENU */}
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl2}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          open={trainingsMenuOpen}
          onClose={handleTrainingsClose}
        >

          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/trainings"
          >
            <ListItemIcon>
              <SchoolIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Body + Life Trainings" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/specialtytrainings"
          >
            <ListItemIcon>
              <SchoolIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Specialty Trainings" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/finder/training"
          >
            <ListItemIcon>
              <SearchIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find a Training" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/finder/trainer"
          >
            <ListItemIcon>
              <SearchIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find a Trainer" />
          </MenuItem>


        </Menu>

        {/* EVENTS MENU */}
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl3}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          open={eventsMenuOpen}
          onClose={handleEventsClose}
        >
          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/event-intro"
          >
            <ListItemIcon>
              <InfoIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Introduction to Nia Events" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleTrainingsClose}
            component={Link}
            to="/debbie-rosas-events"
          >
            <ListItemIcon>
              <EventIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Debbie Rosas Events" />
          </MenuItem>
          <Divider />

          <MenuItem
            onClick={handleEventsClose}
            component={Link}
            to="/finder/event"
          >
            <ListItemIcon>
              <SearchIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Find an Event" />
          </MenuItem>

        </Menu>

        {/* SHOP MENU */}
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl5}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          open={shopMenuOpen}
          onClose={handleShopClose}
        >
          {/*<MenuItem
            onClick={handleShopClose}
            component={Link}
            to="/shop/home"
          >
            <ListItemIcon>
              <HomeIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </MenuItem>
          <Divider />*/}
          <a target="_blank" rel="noopener noreferrer" className={classes.externalLink} href="https://niawear.com">
            <MenuItem
              onClick={handleShopClose}
            >
              <ListItemIcon>
                <img src={ClothingIcon} alt="clothing icon" className={classes.navIconCustom} />
              </ListItemIcon>
              <ListItemText primary="NiaWear" />
            </MenuItem>
          </a>
          <Divider />
          <MenuItem
            onClick={handleShopClose}
            component={Link}
            to="/shop/music"
          >
            <ListItemIcon>
              <LibraryMusic color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Music" />
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={handleShopClose}
            component={Link}
            to="/shop/routines"
          >
            <ListItemIcon>
              <img src={RoutineIcon} alt="routine icon" className={classes.navIcon} />
            </ListItemIcon>
            <ListItemText primary="Routines" />
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={handleShopClose}
            component={Link}
            to="/shop/videos"
          >
            <ListItemIcon>
              <VideoLibrary color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Videos" />
          </MenuItem>
        </Menu>

        {/* LOGGED IN MENU */}
        {user && (
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl6}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
            transformOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
            open={userMenuOpen}
            onClose={handleUserClose}
          >
            <MenuItem
              onClick={handleUserClose}
              component={Link}
              to="/account/home"
            >
              <ListItemIcon>
                <HomeIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="My Account" />
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={handleUserClose}
              component={Link}
              to="/logout"
            >
              <ListItemIcon>
                <img alt="logout icon" src={LogoutIcon} className={classes.navIcon} />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </MenuItem>
          </Menu>
        )}

        {/* MOBILE MENU */}
        <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={mobileMenuOpen}
          onClose={handleMobileMenuClose}
        >

          {/* LOGGED IN */}
          {user && (
            <MenuItem
              onClick={handleUserMenu}
            >
              <p>Account</p>
            </MenuItem>
          )}
          {/* LOGGED OUT */}
          {!user && (
            <MenuItem
              onClick={handleMobileMenuClose}
              component={Link}
              to="/login"
            >
              <p>Login</p>
            </MenuItem>
          )}
          <MenuItem
            onClick={handleAboutMenu}
          >
            <p>About</p>
          </MenuItem>

          <a target="_blank" rel="noopener noreferrer" className={classes.externalLink} href="https://niaondemand.com">
            <MenuItem>
              <ListItemText primary="On Demand" />
            </MenuItem>
          </a>

          <MenuItem
            onClick={handleClassesMenu}
          >
            <p>Classes</p>
          </MenuItem>

          <MenuItem
            onClick={handleTrainingsMenu}
          >
            <p>Trainings</p>
          </MenuItem>

          {/*<MenuItem
            onClick={handleEventsMenu}
          >
            <p>Events</p>
          </MenuItem>*/}


          {/*<a className={classes.externalLink} href="/membership">
            <MenuItem>
              <ListItemText primary="Teach" />
            </MenuItem>
          </a>*/}

          {/*<MenuItem
            onClick={handleMembershipMenu}
          >
            <p>Membership</p>
          </MenuItem> */}

          <MenuItem
            onClick={handleShopMenu}
          >
            <p>Shop</p>
          </MenuItem>

          <MenuItem
            component={Link}
            to="/teach"
          >
            <p>Teach</p>
          </MenuItem>

          {/*<a className={classes.externalLink} href="/join">
            <MenuItem>
              <ListItemText primary="Join" />
            </MenuItem>
          </a>*/}

          {/* Google Translate div gets filled by script */}
          <MenuItem
            onClick={
              () => this.simulateClick()
            }
          >
            <p>Translate</p>
          </MenuItem>

        </Menu>
      </React.Fragment>
    );
  }
}

NavMenus.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  anchorEl0: PropTypes.object,
  anchorEl6: PropTypes.object,
  anchorEl5: PropTypes.object,
  // anchorEl4: PropTypes.object,
  anchorEl3: PropTypes.object,
  anchorEl2: PropTypes.object,
  anchorEl: PropTypes.object,
  mobileMoreAnchorEl: PropTypes.object,
  aboutMenuOpen: PropTypes.bool.isRequired,
  handleAboutMenu: PropTypes.func.isRequired,
  handleAboutClose: PropTypes.func.isRequired,
  shopMenuOpen: PropTypes.bool.isRequired,
  handleShopMenu: PropTypes.func.isRequired,
  handleShopClose: PropTypes.func.isRequired,
  trainingsMenuOpen: PropTypes.bool.isRequired,
  handleTrainingsMenu: PropTypes.func.isRequired,
  handleTrainingsClose: PropTypes.func.isRequired,
  eventsMenuOpen: PropTypes.bool.isRequired,
  handleEventsMenu: PropTypes.func.isRequired,
  handleEventsClose: PropTypes.func.isRequired,
  // membershipMenuOpen: PropTypes.bool.isRequired,
  // handleMembershipMenu: PropTypes.func.isRequired,
  // handleMembershipClose: PropTypes.func.isRequired,
  classesMenuOpen: PropTypes.bool.isRequired,
  handleClassesMenu: PropTypes.func.isRequired,
  handleClassesClose: PropTypes.func.isRequired,
  userMenuOpen: PropTypes.bool.isRequired,
  handleUserMenu: PropTypes.func.isRequired,
  handleUserClose: PropTypes.func.isRequired,
  mobileMenuOpen: PropTypes.bool.isRequired,
  handleMobileMenuClose: PropTypes.func.isRequired,
};

export default NavMenus;
